/* Number ops */

import HTTP from "./http.service";
import Storage from "./storage.service";

var Products = {};

Products.saveProduct = (product_code = null) => {
	let config = {
		method: "post",
		url: "/products/save",
		data: {
			product_code: product_code ? product_code : Storage.get("selectedProduct")
		},
		headers: {
			// "accept-version": "v17",
			"cache-control": "no-cache"
		}
	};
	return HTTP(config);
};

Products.fetchProducts = (categories = "Commitment") => {
	let params = "";
	if (categories) {
		params = "?category=" + categories;
	}
	let config = {
		method: "get",
		url: "/products/available" + params
	};
	return HTTP(config);
};
Products.fetchProductsWithAvailablePlans = (product_codes = "1", service_types = "1", include_Vanity_Plan = "1") => {
	let params = "?include_Vanity_Plan=1&include_optional_promotions=true&product_codes=1&service_types=1";
	let config = {
		method: "get",
		url: "/products/available_plans" + params,
		headers: {
			// "accept-version": "v18",
			"cache-control": "no-cache"
		}
	};
	return HTTP(config);
};

Products.setAllowedFeatures = (product) => {
	if (product && product.AllowedFeatures) {
		let features = [];
		for (let feature of product.AllowedFeatures) {
			features.push(feature.Code);
		}
		Storage.set("allowed_features", features, true);
	}
};

Products.isFeatureAllowed = (feature_code) => {
	let features = Storage.get("allowed_features", true) || [];
	return features.indexOf(feature_code) !== -1;
};

Products.fetchAllowedFeatures = () => {
	Products.getCurrentProduct().then((data) => {
		if (data && data.data) {
			if (data.data.product) {
				Products.setAllowedFeatures(data.data.product);
			}
		}
	});
};

Products.processProducts = rawData => {
	let processed = {};
	for (let product of rawData) {
		processed[product.ProductCode] = product;
	}
	return processed;
};

Products.fetchAllProducts = () => {
	let config = {
		method: "get",
		url: "/products"
	};
	return HTTP(config);
};


Products.fetchAllActiveProductsCode = () => {
	let config = {
		method: "get",
		url: "/products/available?productAttribute=Regular"
	};
	return HTTP(config);
};
Products.selectProduct = product_code => {
	Storage.set("selectedProduct", product_code);
};

Products.saveCurrentProduct = () => {
	let config = {
		method: "get",
		url: "/products/current?save=true&random=" + Date.parse(new Date())
	};
	return HTTP(config);
};

Products.getCurrentProductCommitment = (current = null) => {
	// let products = Storage.get("products");
	// if (!current) {
	// 	current = Storage.get("selectedProduct");
	// }
	// for (let product of products) {
	// 	if ("" + current === "" + product.ProductCode) {
	// 		return product.CommitmentDuration;
	// 	}
	// }
	let products = JSON.parse(Storage.get("ALLProductCodes"));
	if (!current) {
		current = Storage.get("selectedProduct");
	}
	if (products && products[current]) {
		return products[current].CommitmentDuration;
	}
	return "";
};


Products.getCurrentProduct = () => {
	let config = {
		method: "get",
		url: "/products/current"
	};
	return HTTP(config);
};

export default Products;